import React, { useState, useEffect } from 'react';
import { FaMapMarkedAlt, FaBus, FaUsers, FaRedo } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import RoutesComponent         from './Routes/Routes';
import BusesComponent          from './Buses/Buses';
import AllocationComponent     from './Allocation/Allocation';
import PromoteTransportComponent from './PromoteTransport/PromoteTransport';
import './Transport.css';

const Transport = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('routes');

  useEffect(() => {
    if (location.state?.tab) setActiveTab(location.state.tab);
  }, [location.state]);

  const tabs = [
    { key: 'routes',     label: 'Routes',     icon: <FaMapMarkedAlt /> },
    { key: 'buses',      label: 'Buses',      icon: <FaBus /> },
    { key: 'allocation', label: 'Allocation', icon: <FaUsers /> },
    { key: 'promote',    label: 'Promote',    icon: <FaRedo /> },
  ];

  return (
    <div className="student-transport-container">
      <h2 className="student-transport-title">Transport Management</h2>

      <div className="att-nav-row">
        {tabs.map(t => (
          <button
            key={t.key}
            className={`att-nav-btn ${activeTab === t.key ? 'att-nav-btn-active' : ''}`}
            onClick={() => setActiveTab(t.key)}
          >
            <span className="att-nav-icon">{t.icon}</span>
            {t.label}
          </button>
        ))}
      </div>

      <div className="student-transport-content">
        {activeTab === 'routes'     && <RoutesComponent />}
        {activeTab === 'buses'      && <BusesComponent />}
        {activeTab === 'allocation' && <AllocationComponent />}
        {activeTab === 'promote'    && <PromoteTransportComponent />}
      </div>
    </div>
  );
};

export default Transport;
